import React, { useContext } from 'react';
import classNames from 'classnames';
import { StyleContext } from 'utils/context/StyleContextProvider';
import BlogArticle from './BlogArticle';
import BlogArticles from './BlogArticles';

export default function BlogHero({ blog, blogs, featured, limit = 3 }) {
    const styles = useContext(StyleContext),
        featuredBlogs = featured,
        featuredBlogsLength = featuredBlogs?.length || 0;
    let blogArticles = blogs.blogs,
        skip = 0;

    if (!blogArticles) {
        return null;
    }

    if (blog) {
        blogArticles = [...new Set([blog, ...blogArticles])];
    } else {
        skip++;
    }

    return (
        <section className={classNames(styles.blog__Hero)}>
            <BlogArticle blog={blogArticles[0]} isHero />
            <BlogArticles
                featuredBlogs={featuredBlogs}
                blogArticles={blogs}
                limit={limit - featuredBlogsLength}
                skip={skip}
                excludedBlogs={[blog?.slug]}
            />
        </section>
    );
}
